import { Text } from "@clipboard-health/ui-components";
import {
  type PlacementCandidate,
  PlacementCandidateScreeningStatus,
} from "@src/appV2/redesign/PlacementCandidate/types";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { getVerifiedType, PLACEMENT_VERIFIED_TYPES } from "../../../utils/verified-placement";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface ResponseTimeSectionProps {
  placement: PlacementWithDetails;
  placementCandidate: PlacementCandidate;
}

export function ResponseTimeSection(props: ResponseTimeSectionProps) {
  const { placement, placementCandidate } = props;

  const verifiedType = getVerifiedType(placement);

  const responseTimeMap = {
    [PLACEMENT_VERIFIED_TYPES.INSTANT_INTERVIEW]:
      "Zero wait time. You can instantly book an in-person interview at this workplace.",
    [PLACEMENT_VERIFIED_TYPES.REQUEST_INTERVIEW]:
      "Send your requested dates and times to the workplace. Within 3 business days, they'll respond to you through in app chat and coordinate from there.",
    [PLACEMENT_VERIFIED_TYPES.APPLY]:
      "The workplace recruiter will be in touch with you. If they're interested in your application, they'll reach out to schedule an interview.",
    [PLACEMENT_VERIFIED_TYPES.APPLY_ON_WEB]:
      placementCandidate.screeningStatus === PlacementCandidateScreeningStatus.PASSED_EXCEPTIONALLY
        ? "After applying, a Clipboard recruiter will get back to you within 3 business days the status of your application."
        : "Clipboard isn't managing this job directly. The workplace may take 7+ days to reach out to you",
  };

  return (
    <PlacementSectionTemplate title="Response time" iconType="stop-watch">
      <Text variant="body2">{responseTimeMap[verifiedType]}</Text>
    </PlacementSectionTemplate>
  );
}
